var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerNormal"},[_c('div',{staticClass:"head"},[_c('font',[_vm._v(_vm._s(_vm.title))])],1),_vm._t("containerNormal")],2)}
var staticRenderFns = []

export { render, staticRenderFns }